import React, { useState } from 'react';

const LoginForm = ({ onLogin, onSwitchToRegister, error }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await onLogin({ username, password });
        setLoading(false);
    };

    return (
        <div style={{ padding: '1rem' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                <i className="fas fa-leaf" style={{ color: 'var(--primary)' }}></i> Вход в Echo
            </h3>

            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-user"></i> Имя пользователя
                    </label>
                    <input
                        type="text"
                        className="message-input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Введите имя пользователя"
                        required
                        style={{ width: '100%' }}
                    />
                </div>

                <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' }}>
                        <i className="fas fa-lock"></i> Пароль
                    </label>
                    <input
                        type="password"
                        className="message-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Введите пароль"
                        required
                        style={{ width: '100%' }}
                    />
                </div>

                {error && (
                    <div style={{
                        background: 'rgba(231, 76, 60, 0.1)',
                        color: '#e74c3c',
                        padding: '0.5rem',
                        borderRadius: '8px',
                        marginBottom: '1rem',
                        fontSize: '0.85rem',
                        textAlign: 'center'
                    }}>
                        <i className="fas fa-exclamation-triangle"></i> {error}
                    </div>
                )}

                <button
                    type="submit"
                    className="btn-primary"
                    disabled={loading}
                    style={{ width: '100%', marginBottom: '1rem' }}
                >
                    {loading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-sign-in-alt"></i>}
                    {loading ? ' Вход...' : ' Войти'}
                </button>

                <p style={{ textAlign: 'center', fontSize: '0.85rem' }}>
                    Нет аккаунта?{' '}
                    <button
                        type="button"
                        onClick={onSwitchToRegister}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'var(--primary)',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                    >
                        Зарегистрироваться
                    </button>
                </p>

            </form>
        </div>
    );
};

export default LoginForm;
